exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".hipster{display:inline-block;height:217px;background:url(" + require("../../content/images/background_jyogui-logo.png") + ") no-repeat top;background-size:contain}@media only screen and (-o-min-device-pixel-ratio:2/1),only screen and (-webkit-min-device-pixel-ratio:2),only screen and (min--moz-device-pixel-ratio:2),only screen and (min-device-pixel-ratio:2),only screen and (min-resolution:2dppx),only screen and (min-resolution:192dpi){.hipster{background:url(" + require("../../content/images/background_jyogui-logo.png") + ") no-repeat top;background-size:contain}}.jyogui-info-box{background-color:#f8f9fa;border:1px solid #dee2e6;padding:1rem;border-radius:.25rem;color:#6c757d}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/main/webapp/app/home/home.scss
// module id = 879
// module chunks = 0